import { Grid } from "@mui/material";
import React from "react";
import PropTypes from "prop-types";
import HorizontalBarChart from "examples/Charts/BarCharts/HorizontalBarChart";

export function ChartsBySector({ companiesSalesBySector }) {
  // param: salesBySectorSummaryList: list of Object SalesBySectorSummaryModel

  return (
    <div>
      <Grid container spacing={1}>
        {companiesSalesBySector.map((companySummary) =>
          React.cloneElement(
            <>
              <Grid item lg={12}>
                <HorizontalBarChart
                  height={"24rem"}
                  icon={{ color: "dark", component: "leaderboard" }}
                  title={"Empresa " + companySummary.company + ". Ventas Por Sector"}
                  description={"Ventas Totales: $" + Number(companySummary.total).toLocaleString()}
                  chart={{
                    labels: Object.keys(companySummary.sectors)
                      .filter((e) => {
                        return companySummary.sectors[e].sale > 0;
                      })
                      .map((e) => {
                        return companySummary.sectors[e].name;
                      }),
                    datasets: [
                      {
                        label: "Ventas en el sector",
                        color: companySummary.color,
                        data: Object.keys(companySummary.sectors)
                          .filter((e) => {
                            return companySummary.sectors[e].sale > 0;
                          })
                          .map((e) => {
                            return Number(companySummary.sectors[e].sale);
                          }),
                      },
                    ],
                  }}
                />
              </Grid>
            </>
          )
        )}
      </Grid>
    </div>
  );
}

ChartsBySector.defaultProps = {
  companiesSalesBySector: [],
};

ChartsBySector.propTypes = {
  companiesSalesBySector: PropTypes.array,
};
